// @flow

import * as React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { withEntityPermissions } from '@gandi/acl';
import { contactbook } from '@gandi/redux-resource-contactbook';

import { withLogger } from 'gandi.redux-logger';

import { withRouter } from 'src/helpers/withRouter';
import type { FullState, MapDispatchToProps } from 'src/types';

import { getBaseContact } from '../../DomainContacts/Wizard/modules/actions';
import { selectSetupOwner } from '../modules/selectors';

import Presenter from './Presenter';
import type { StateProps, DispatchProps } from './Presenter';
import { selectContacts } from './modules/selectors';

const fetchProps = {};

const mapStateToProps = (state: FullState): StateProps => {
  const contactbookOrgId = selectSetupOwner(state);

  const isContactListLoaded = contactbook.selectIsLoaded(
    state,
    contactbookOrgId,
    fetchProps,
  );
  const isContactListFailure = contactbook.selectIsFailure(
    state,
    contactbookOrgId,
    fetchProps,
  );
  const isFetchingContactList = contactbook.selectIsFetching(
    state,
    contactbookOrgId,
    fetchProps,
  );
  const isContactListToRefetch = contactbook.selectIsToRefetch(
    state,
    contactbookOrgId,
    fetchProps,
  );

  const shouldFetchContactList =
    !isFetchingContactList &&
    ((!isContactListLoaded && !isContactListFailure) || isContactListToRefetch);

  const contacts = selectContacts(state, contactbookOrgId);

  return {
    shouldFetchContactList,
    contacts,
    contactbookOrgId,
    isFetching: isFetchingContactList,
    isContactListLoaded,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps> = {
  fetchContactList: contactbook.fetchContactList,
  getBaseContact,
};

// FIXME: unused source file
export default (compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withEntityPermissions(props => ({
    entity: props.contactbookOrgId,
    hasPermissions: {
      canReadContactBook: ['organizations:contactbook:read'],
      canWriteContactBook: ['organizations:contactbook:write'],
    },
  })),
  withLogger('ModifyDomainContact/Presenter'),
)(Presenter): React.ComponentType<{}>);
